import { useBlocker, useNavigate } from 'react-router-dom';
import Button from '../../../../../component/ui/Button';
import { useEffect, useState } from 'react';
import DoctorForm from './doctorForm';
import { toast } from 'react-toastify';
import { master_data } from '../../../../../store/action/master';
import { getCities } from '../../../../../services/vendor';
import { hasPermission, newObjectCreater } from '../../../../../utils/controller';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../../../../component/modal/Modal';
import { createDoctor } from '../../../../../services/doctors';

const CreateDoctor = () => {
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [errors, setError] = useState({});
	const dispatch = useDispatch();
	const [cityList, setCityList] = useState([]);
	const [isNextLocation, setIsNextLocation] = useState(null);
	const [isLocationBlocker, setIsLocationBlocker] = useState(true);
	const [isDoctorAutoSave, setIsDoctorAutoSave] = useState(false);
	const [activeTab, setActiveTab] = useState('Other Details');
	const [isLoading, setLoading] = useState(false);
	const [isEditProfile, setIsEditProfile] = useState(false);
	const [doctorData, setDoctorData] = useState({
		basicDetails: {
			doctor_type_id: null,
			doctor_name: '',
			profile_url: null,
			business_name: '',
			doctor_display_name: '',
			doctor_email: '',
			doctor_phone_mobile: '',
			doctor_phone_work: '',
		},
		othersDetails: {
			registration_number: '',
			is_enable_portal: false,
		},
		address: {
			attention: '',
			country_id: '',
			street_1: '',
			street_2: '',
			city_id: null,
			state_id: null,
			zip_code: '',
		},
		doctorRemark: {
			remark_text: '',
		},
	});
	const [doctorDocs, setDoctorDocs] = useState({
		registration_doc: null,
	});

	const checkValidation = () => {
		var error = { ...errors };
		if (
			!doctorData.othersDetails.registration_number ||
			doctorData.othersDetails.registration_number === undefined ||
			doctorData.othersDetails.registration_number === ''
		) {
			setActiveTab('Other Details');
			error.registration_number =
				'Please enter registration number(As Per State Medical Council) in the field';
		} else {
			delete error.registration_number;
		}
		if (
			!doctorData.basicDetails.doctor_name ||
			doctorData.basicDetails.doctor_name === undefined ||
			doctorData.basicDetails.doctor_name === ''
		) {
			error.doctor_name = 'Please enter doctor name in the field';
		} else {
			delete error.doctor_name;
		}
		if (
			!doctorData.basicDetails.business_name ||
			doctorData.basicDetails.business_name === undefined ||
			doctorData.basicDetails.business_name === ''
		) {
			error.business_name = 'Please enter business name in the field';
		} else {
			delete error.business_name;
		}
		if (
			!doctorData.basicDetails.doctor_display_name ||
			doctorData.basicDetails.doctor_display_name === undefined ||
			doctorData.basicDetails.doctor_display_name === ''
		) {
			error.doctor_display_name = 'Please select valid doctor display name in the list';
		} else {
			delete error.doctor_display_name;
		}
		if (Object.keys(error).length > 0) {
			setError(error);
			return true;
		} else {
			return false;
		}
	};

	const handleSaveDoctor = async (status) => {
		const checkError = checkValidation();
		if (checkError) {
			toast.error('Please fill all mandatory fields before saving');
		} else {
			setLoading(true);
			const formData = new FormData();
			const doctorObj = {
				doctor_type_id: doctorData.basicDetails.doctor_type_id,
				status: status,
				name: doctorData.basicDetails.doctor_name,
				display_name: doctorData.basicDetails.doctor_display_name,
				business_name: doctorData.basicDetails.business_name,
				email: doctorData.basicDetails.doctor_email,
				phone: doctorData.basicDetails.doctor_phone_work,
				mobile: doctorData.basicDetails.doctor_phone_mobile,

				is_enable_portal: doctorData.othersDetails.is_enable_portal,
				registration_number: doctorData.othersDetails.registration_number,

				attention:
					doctorData.address.attention !== '' && doctorData.address.attention !== null
						? doctorData.address.attention
						: '',
				country_id:
					doctorData.address.country_id !== '' && doctorData.address.country_id !== null
						? doctorData.address.country_id
						: '',
				city_id:
					doctorData.address.city_id !== '' && doctorData.address.city_id !== null
						? doctorData.address.city_id
						: '',
				street_1:
					doctorData.address.street_1 !== '' && doctorData.address.street_1 !== null
						? doctorData.address.street_1
						: '',
				street_2:
					doctorData.address.street_2 !== '' && doctorData.address.street_2 !== null
						? doctorData.address.street_2
						: '',
				state_id:
					doctorData.address.state_id !== '' && doctorData.address.state_id !== null
						? doctorData.address.state_id
						: '',
				zipcode:
					doctorData.address.zip_code !== '' && doctorData.address.zip_code !== null
						? doctorData.address.zip_code
						: '',
			};
			for (const key in doctorObj) {
				formData.append(key, doctorObj[key]);
			}

			if (doctorData.doctorRemark.remark_text) {
				formData.append('remarks', doctorData.doctorRemark.remark_text);
			}

			if (doctorDocs.registration_doc) {
				formData.append('registration_doc', doctorDocs.registration_doc);
			}
			if (doctorData.basicDetails.profile_url) {
				formData.append('profile_url', doctorData.basicDetails.profile_url);
			}

			try {
				const res = await createDoctor(formData);
				if (res?.success) {
					toast.success(res?.message);
					setIsLocationBlocker(false);
					setIsDoctorAutoSave(false);
					setTimeout(() => {
						navigate(`/user/${suburl}/doctors`);
					}, 300);
				} else {
					toast.error(res?.message || 'Something went wrong');
				}
			} catch (error) {
				toast.error(error?.message || 'Something went wrong');
			} finally {
				setLoading(false);
			}
		}
	};

	async function getCity(stateId) {
		try {
			var body = {
				state_id: Number(stateId),
			};
			var res = await getCities(body);
			if (res?.success) {
				var cities = newObjectCreater(res?.data);
				setCityList(cities);
			}
		} catch (error) {
			toast.error(error);
		}
	}

	useBlocker((tx) => {
		if (isLocationBlocker) {
			setIsNextLocation(tx);
			setIsDoctorAutoSave(true);
			return true;
		}
		return false;
	});

	useEffect(() => {
		dispatch(master_data());
	}, [dispatch]);

	useEffect(() => {
		getCity(doctorData.address.state_id);
	}, [doctorData.address.state_id]);

	return (
		<div>
			<div className="product-pg-header add-product">
				<p>Create New Doctor</p>
				<div className="add-product-button">
					<Button
						type="button"
						className="btn-primary mt-0 px-4"
						button="Save"
						loader={isLoading}
						disabled={
							isLoading || !hasPermission('sales.doctors.create', user?.role?.role_permissions)
						}
						onClick={() => {
							setIsDoctorAutoSave(false);
							handleSaveDoctor(1);
						}}
					/>
					<Button
						type="button"
						className="mt-0 btn-danger add-pro"
						button=""
						close
						onClick={() => navigate(`/user/${suburl}/doctors`)}
					/>
				</div>
			</div>
			<DoctorForm
				setDoctorData={setDoctorData}
				doctorData={doctorData}
				doctorDocs={doctorDocs}
				setDoctorDocs={setDoctorDocs}
				error={errors}
				setError={setError}
				isEdit={false}
				cityList={cityList}
				setIsEditProfile={setIsEditProfile}
				activeTab={activeTab}
				setActiveTab={setActiveTab}
			/>
			{isDoctorAutoSave && (
				<Modal
					className="deleteVendorsModal"
					title="Doctor Auto Save"
					isOpen={isDoctorAutoSave}
					onClose={() => {
						setIsDoctorAutoSave(false);
					}}
					cancelButton={() => {
						setIsDoctorAutoSave(false);
					}}
				>
					<div
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '20px 10px',
							marginBottom: '20px',
							borderRadius: '5px',
							fontWeight: '600',
							color: 'black',
						}}
					>
						You have unsaved changes. Do you want to continue without saving?
					</div>

					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: 10,
							justifyContent: 'end',
						}}
					>
						<Button
							type="button"
							button="Leave Without Saving"
							className="mt-0 px-4 btn-danger relative"
							onClick={() => {
								setIsLocationBlocker(false);
								setIsDoctorAutoSave(false);
								setTimeout(() => {
									navigate(isNextLocation.nextLocation?.pathname);
								}, 300);
							}}
						/>
						<Button
							type="button"
							button="Save and Continue"
							disabled={!hasPermission('sales.doctors.create', user?.role?.role_permissions)}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => {
								setIsDoctorAutoSave(false);
								handleSaveDoctor(1);
							}}
						/>
					</div>
				</Modal>
			)}
		</div>
	);
};
export default CreateDoctor;
